// This is the Hustlance Blog's own standalone site — routes are flat (no
// /blog prefix) since the site root IS the blog. PageType key names are kept
// identical to the original in-Hustlance-app version (blog-home, admin-blog-*,
// etc.) even though the path *values* are now flat — this let every page
// component that already referenced these keys work unchanged.
export type PageType =
  | 'blog-home' | 'blog-all-news' | 'blog-search' | 'blog-about' | 'blog-contact'
  | 'blog-account' | 'blog-account-liked' | 'blog-account-comments'
  | 'admin-blog-dashboard' | 'admin-blog-posts' | 'admin-blog-post-new' | 'admin-blog-post-edit'
  | 'admin-blog-comments' | 'admin-blog-categories' | 'admin-blog-settings' | 'admin-blog-messages';

export const PAGE_PATHS: Record<PageType, string> = {
  'blog-home': '/',
  'blog-all-news': '/news',
  'blog-search': '/search',
  'blog-about': '/about',
  'blog-contact': '/contact',
  'blog-account': '/account',
  'blog-account-liked': '/account/liked',
  'blog-account-comments': '/account/comments',
  'admin-blog-dashboard': '/admin',
  'admin-blog-posts': '/admin/posts',
  'admin-blog-post-new': '/admin/posts/new',
  'admin-blog-post-edit': '/admin/posts/edit',
  'admin-blog-comments': '/admin/comments',
  'admin-blog-categories': '/admin/categories',
  'admin-blog-settings': '/admin/settings',
  'admin-blog-messages': '/admin/messages',
};

// Parameterized routes (article slug, category slug, post id) can't live in
// the fixed PAGE_PATHS map above.
export const blogArticlePath = (slug: string) => `/article/${slug}`;
export const blogCategoryPath = (categorySlug: string) => `/category/${categorySlug}`;
export const adminBlogPostEditPath = (id: string) => `/admin/posts/edit?id=${id}`;

// Canonical URL of the main Hustlance app and its social accounts — used for
// the "back to Hustlance" link and social icons in the nav bar/footer, since
// this is a different site/domain now.
export const HUSTLANCE_URL = 'https://hustlance.com';
export const HUSTLANCE_INSTAGRAM_URL = 'https://www.instagram.com/hustlance.official/';
export const HUSTLANCE_REDDIT_URL = 'https://www.reddit.com/user/Hustlance-Official/';
export const HUSTLANCE_DISCORD_URL = 'https://discord.gg/HCnpJNd6K';
export const HUSTLANCE_LINKEDIN_URL = 'https://www.linkedin.com/company/hustlance-official/';
